<template>
    <v-container fluid px-3 pt-3>
        <v-row row wrap>
            <v-col cols="12">
                <h3>Marriage Verification</h3>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row row wrap>
            <v-col>
                <v-card>
                    <v-form v-model="formValid" ref="marriageVerForm">
                        <v-container>
                            <v-row>
                                <v-col cols="12">
                                    <h4>Spouse 1</h4>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">Legal Name prior to first marriage</v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="3" pt-0>
                                    <v-text-field dense label="First Name" v-model="marriageVerificationDto.firstName" required :rules="requiredRule"></v-text-field>
                                </v-col>
                                <v-col cols="3" pt-0>
                                    <v-text-field dense label="Middle Name" v-model="marriageVerificationDto.middleName" :persistent-hint="true" hint="Optional"></v-text-field>
                                </v-col>
                                <v-col cols="3" pt-0>
                                    <v-text-field dense label="Last Name" v-model="marriageVerificationDto.lastName" required :rules="requiredRule"></v-text-field>
                                </v-col>
                                <v-col cols="3" pt-0>
                                    <v-text-field dense label="Birthdate" validate-on-blur type="date" v-model="marriageVerificationDto.dateOfBirth" required :rules="dobRules"
                                                  persistent-hint :hint="marriageVerificationDto.dateOfBirth2 ? 'Optional' : ''">
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <h4>Spouse 2</h4>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">Legal Name prior to first marriage</v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="3">
                                    <v-text-field dense label="First Name" v-model="marriageVerificationDto.firstName2" required :rules="requiredRule"></v-text-field>
                                </v-col>
                                <v-col cols="3">
                                    <v-text-field dense label="Middle Name" v-model="marriageVerificationDto.middleName2" :persistent-hint="true" hint="Optional"></v-text-field>
                                </v-col>
                                <v-col cols="3">
                                    <v-text-field dense label="Last Name" v-model="marriageVerificationDto.lastName2" required :rules="requiredRule"></v-text-field>
                                </v-col>
                                <v-col cols="3">
                                    <v-text-field dense label="Birthdate" validate-on-blur type="date" v-model="marriageVerificationDto.dateOfBirth2" required :rules="dobRules2"
                                                  persistent-hint :hint="marriageVerificationDto.dateOfBirth ? 'Optional' : ''">
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="3">
                                    <v-text-field label="Marriage Year" persistent-hint hint="Optional" type="int" v-model="intYear">
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="6">
                                    <!--<v-select label="Reason for Verification" v-model="marriageVerificationDto.verificationReason"
                                        required :rules="requiredRule"
                                        :items="reasons">
                                    </v-select>-->
                                    <b>This verification is for government use only. Please enter in some information related to your request (Employee ID, Request ID, etc.)</b>
                                </v-col>
                                <v-col cols="6">
                                    <v-text-field label="Additional Information" v-model="verificationReasonExtraInfo" :rules="requiredRule" required></v-text-field>
                                </v-col>
                            </v-row>
                            <div v-if="errors.length > 0">
                                <v-row  v-for="error in errors" :key="error">
                                    <b style="color:red">{{error}}</b>
                                </v-row>
                            </div>
                            <v-row>
                                <v-col cols="12">
                                    <v-btn color="secondary" :disabled="isLoading || !formValid" @click="sendMarriageVerification">
                                        SUBMIT
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-card>
            </v-col>
        </v-row>
        <div v-if="!!response && response.matchedRecords.length === 1">
            <v-row>
                <v-col>
                    <v-icon color="green">mdi-check-circle</v-icon>
                    <label>  Verified!</label>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-data-table
                        :items="response.matchedRecords"
                        :headers="headers"
                        item-key="marriageId">
                    </v-data-table>
                </v-col>
            </v-row>

            <v-row >
                <v-col cols="12">
                    If you would like a complete abstract for this request please contact VSS.
                </v-col>
                <v-col cols="12" v-show="abstractRequested">
                    An abstract has been requested, once approved you will see it in your inbox.
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="2">
                    <v-btn @click="contactVSSForAbstract" :disabled="abstractRequested">Request Abstract</v-btn>
                </v-col>
                <v-col cols="2">
                    <v-btn @click="printVerification" :disabled="isPrinting">Print</v-btn>
                </v-col>
            </v-row>
        </div>
        <div v-else-if="!!response && response.matchedRecords.length > 1">
            <v-row>
                <v-col>
                    <v-icon color="yellow">mdi-help-circle</v-icon>
                    <label>  Potential Matches</label>
                </v-col>
            </v-row>
            <v-row >
                <v-col cols="6">
                    There is more than one match for this request. Please contact VSS.
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="2">
                    <v-btn @click="contactVSS(4)">Contact VSS</v-btn>
                </v-col>
            </v-row>
        </div>
        <div v-else-if="!!response && response.matchedRecords.length === 0">
            <v-row>
                <v-col>
                    <v-icon color="red">mdi-close-circle</v-icon>
                    <label>  Not Verified</label>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="6">
                    If you believe this to be an error you may contact VSS for a more refined search.
                </v-col>
            </v-row>
        </div>
        <v-row v-if="contact">
            <v-col cols="12" v-if="sent">
                Message Sent!
            </v-col>
            <v-col col="12" >
                <v-textarea autofocus auto-grow v-model="mailItem.message" :disabled="sent || isLoading" ></v-textarea>
            </v-col>
            <v-col col="2">
                <v-btn @click="sendMessage" :disabled="!ready || sent || isLoading">Send</v-btn>
            </v-col>
        </v-row>
        <contact-vss :operationType="operationType" :requestId="requestId" :modType="20" :numMatches="numberOfMatches"></contact-vss>
    </v-container>
</template>

<script>
import mailService from '@/services/mailService'
import verificationService from '@/services/verificationService'
import mediaService from '@/services/mediaService'
import ContactVss from '../components/ContactVss.vue'

export default {
    components: { ContactVss },
    data: () => {
        return {
            isLoading: false,
            isPrinting: false,
            abstractRequested: false,
            contact: false,
            intYear: '',
            marriageVerificationDto: {
                firstName: '',
                middleName: '',
                lastName: '',
                dateOfBirth: '',
                firstName2: '',
                middleName2: '',
                lastName2: '',
                dateOfBirth2: '',
                recordYear: null,
                matched: null,
                verificationReason: ''
            },
            verificationReasonExtraInfo: '',
            headers: [
                { text: 'First Name 1', value: 'firstName' },
                { text: 'Middle Name 1', value: 'middleName' },
                { text: 'Last Name 1', value: 'lastName' },
                { text: 'Date of Birth 1', value: 'dateOfBirth' },
                { text: 'First Name 2', value: 'firstName2' },
                { text: 'Middle Name 2', value: 'middleName2' },
                { text: 'Last Name 2', value: 'lastName2' },
                { text: 'Date of Birth 2', value: 'dateOfBirth2' },
                { text: 'Marriage Date', value: 'marriageDate' }
            ],
            reasons: [ 'Reason 1' ],
            menu: false,
            verificationSent: false,
            requiredRule: [v => !!v || 'Required', v => v.trim() !== '' || 'Invalid Input'],
            requiredYearRule: [v => !!v || 'Required', v => v > 1800 || 'Must be greater than 1800', v => v < 2200 || 'Must be less than 2200'],
            formValid: false,
            response: '',
            numberOfMatches: null,
            requestId: 0,
            errors: [],
            operationType: mailService.OperationEnum.Verification
        }
    },
    computed: {
        dobRules () {
            return [
                (v) => {
                    if (!(!!v || this.marriageVerificationDto.dateOfBirth2)) {
                        return 'Minimum of one DOB is required.'
                    }
                    return true
                }
            ]
        },
        dobRules2 () {
            return [
                (v) => {
                    if (!(!!v || this.marriageVerificationDto.dateOfBirth)) {
                        return 'Minimum of one DOB is required.'
                    }
                    return true
                }
            ]
        }
    },
    methods: {
        sendMarriageVerification () {
            this.errors = []
            this.$refs.marriageVerForm.validate()
            if (this.formValid) {
                this.isLoading = true
                this.marriageVerificationDto.verificationReason += ' ' + this.verificationReasonExtraInfo
                if (this.intYear || this.intYear.length > 0) {
                    this.marriageVerificationDto.recordYear = new Date(this.intYear, 0, 1)
                }
                verificationService.marriageVerification(this.$http, this.marriageVerificationDto).then(result => {
                    if (result.data && !result.data.errorMessages) {
                        this.response = result.data
                        this.numberOfMatches = this.response.matchedRecords.length
                        this.requestId = result.data.requestId
                    } else {
                        this.errors = result.data.errorMessages
                    }
                    this.verificationSent = true
                    this.isLoading = false
                })
            }
        },
        contactVSSForAbstract () {
            verificationService.verificationRequestAbstract(this.$http, this.requestId)
            this.abstractRequested = true
        },
        printVerification () {
            this.isPrinting = true
            verificationService.verificationPrint(this.$http, this.requestId).then(response => {
                mediaService.fileToDownload(response, 'marriageVerification_request' + this.requestId + '.pdf')
                this.isPrinting = false
            })
        }
    }
}
</script>
